import { render, staticRenderFns } from "./SetupSessionTerms.vue?vue&type=template&id=3277bed7"
import script from "./SetupSessionTerms.vue?vue&type=script&lang=ts"
export * from "./SetupSessionTerms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports